import { Logo } from 'palette/Logo';
import { Typography } from 'palette/Typography';
import { FooterBlock } from './FooterBlock';

import '../styles/FooterNavigationIcons.scss';

export function FooterNavigationIcons({
    icons,
    title,
    disclaimer,
    link,
    customClass
}) {
    return (
        <FooterBlock
            customClass={customClass}
            title={title}
        >
            <div className="react-footer-navigation-icons">
                {icons.map(icon => (
                    <a
                        key={icon}
                        aria-label={icon}
                        className="react-footer-navigation-icons__link"
                        href={link}
                    >
                        <Logo
                            className="react-footer-navigation-icons__icon"
                            name={icon}
                            size="medium"
                        />
                    </a>
                ))}
            </div>
            { disclaimer && (
                <Typography
                    className="react-footer-navigation-icons__disclaimer"
                    color="light"
                    tagName="small"
                    type="small"
                >
                    {/* eslint-disable-next-line react/no-danger */}
                    <span dangerouslySetInnerHTML={{ __html: disclaimer }} />
                </Typography>
            )}
        </FooterBlock>
    );
}
